import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/userSlice";
import landingPageSlice from "./slices/landingPageSlice";
import resourceManagerSlice from "./slices/resourceManagerSlice";
import userManagementSlice from "./slices/userManagementSlice";
import engagementManagerSlice from "./slices/engagementManagerSlice";
import stagesSlice from "./slices/stagesSlice";
import consentSlice from "./slices/consentSlice";
import { thunk } from "redux-thunk";

export default configureStore({
  reducer: {
    user: userSlice,
    landing: landingPageSlice,
    resourceManager: resourceManagerSlice,
    userManagement: userManagementSlice,
    engagementManager: engagementManagerSlice,
    stages: stagesSlice,
    consent: consentSlice,
  },
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
    thunk,
  ],
});
